import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { PositionService } from '../position.service';
import { Message } from 'primeng/primeng';



@Component({
  selector: 'app-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.css'],
  providers: [PositionService]
  // encapsulation: ViewEncapsulation.None
})
export class PositionComponent implements OnInit {

  
  msgs: Message[] = [];
  positions: string[] = [];
  loading: boolean = false;
  routeParams: string = "";


  constructor(
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private positionService: PositionService,
              ) {

              activatedRoute.params.subscribe(params=>{this.routeParams=params['id']});

                  if(this.routeParams){
                     this.load();
                     this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено "+this.routeParams});
                   
              }   

           
               }

  ngOnInit() {
     this.load();
  }

  load(){
    this.loading= true;
    this.positionService.getPosition().subscribe(response=>{this.positions = response['data'];this.loading= false;})
  }

  add(){
  	this.router.navigate(['/dashboard/position-crud']);
  }

  edit(id: any){
  	this.router.navigate(['/dashboard/position-crud/',id]);
  }

  show(){
  	this.router.navigate(['/dashboard/position-crud']);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/positions/position/position.component.ts